import * as d3 from "d3";


document.addEventListener("DOMContentLoaded", function() {
    if (!document.querySelector("#chart")) {
        return
    }
    const data = [55, 35, 20];
    const content = [
        `<h2>Purchase offsets</h2>
         <ul>
           <li>Renewable Energy Certificates (RECs)</li>
           <li>Purchase verified carbon offsets or invest in offset - generating projects</li>
         </ul>
         <h2>Other emerging technologies</h2>
         <ul>
         <li>Next-generation geothermal energy or nuclear energy could supply ~10% of Singapore’s energy needs by 2050</li>
         <li>Carbon Capture, Utilisation and Storage</li>
        </ul>
        <h2>Low carbon fuel</h2>
         <ul>
         <li>Solution for Scope 1 emissions which we are unable to electrify - biofuels, methanol, ammonia, liquified hydrogen</li>
        </ul>
         `
         ,
        `<h2>Renewable energy</h2>
        <ul>
        <li>By 2035, Singapore will import green electricity to meet 30% of its energy needs</li>
        <li>By 2050, Singapore is expected to supply up to 50% of its energy needs with hydrogen</li>
        <li>By 2050, Singapore is expected to supply up to 50% of its energy needs with hydrogen</li>
        <li>SMRT to secure renewable energy via private arrangements</li>
       </ul>`
        ,
        `<h2>Internal Efforts</h2>
        <ul>
        <li>Fleet electrification</li>
        <li>Harnessing renewable energy</li>
        <li>Operational efficiency adjustments</li>
        <li>Infrastructure rejuvenation</li>
       </ul>`
    ];
    const percentages = ["55%*", "35%*", "10%*"];
    const width = 600;
    const height = 600;
    const margin = 40;

    const radius = Math.min(width, height) / 2 - margin;
    const expandedRadius = radius * 1.08;  // 10% larger radius
    const thickness = 110;  // Define the thickness of the segments


    const svg = d3.select("#chart")
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", `translate(${width / 2}, ${height / 2}) rotate(90) scale(-1,1)`);

    const color = d3.scaleOrdinal()
        .domain(data)
        .range(["rgba(229, 229, 229, 0.5)", "rgba(229, 229, 229, 0.3)", "rgba(229, 229, 229, 0.5)"]);

    const pie = d3.pie()
        .startAngle(-Math.PI / 2)
        .endAngle(Math.PI / 2)
        .sort(null)
        .value(d => d);

    const arc = d3.arc()
        .innerRadius(radius - thickness)
        .outerRadius(radius);

    const arcExpanded = d3.arc()
        .innerRadius(radius - thickness)
        .outerRadius(expandedRadius);

    const arcs = svg.selectAll(".arc")
        .data(pie(data))
        .enter()
        .append("g")
        .attr("class", "arc")
        .each(function(d, i) {
            d.index = i;  // Bind the index to each data point
        })
        .on("click", function(event, d) {
            const textContent = content[d.index];
            document.getElementById("text-content").innerHTML = textContent;  // Update HTML content

            // Reset all arcs to normal size and color
            arcs.select("path")
              .transition()
              .duration(500)
              .attr("d", arc)
              .attr("fill", (d, i) => color(i));

          // Expand the clicked arc and change selected to green
          d3.select(this).select("path")
              .transition()
              .duration(500)
              .attr("d", arcExpanded)
              .attr("fill", "#439E3D");
        });

    arcs.append("path")
        .attr("d", arc)
        .attr("fill", (d, i) => color(i));  // Apply the color based on the index

     // Add percentage text
    arcs.append("text")
        .attr("transform", function(d) {
            const pos = arc.centroid(d);
            return "translate(" + (pos[0]-8) + "," + (pos[1]-8) + ") rotate(90) scale(-1,1)";
        })
        .attr("text-anchor", "middle")
        .attr("font-size", "28px")
        .attr("font-weight", "bold")
        .text((d, i) => percentages[i]);

    // Hide the left part of the doughnut
    const clipPath = svg.append("defs")
        .append("clipPath")
        .attr("id", "half-circle");

    clipPath.append("rect")
        .attr("x", -width / 2)
        .attr("y", -height / 2)
        .attr("width", width)
        .attr("height", height / 2);

    svg.selectAll("path")
        .attr("clip-path", "url(#half-circle)");

    // Trigger click event on the first segment - default
    svg.selectAll(".arc")
        .filter((d, i) => i === 0)  // Select the first segment
        .each(function() {
            d3.select(this).dispatch("click");
        });
        
        arcs.append("text")
            .attr("transform", "rotate(90) scale(-1,1)")
            .attr("text-anchor", "middle")
            .attr("dy", "-2em")
            .text("Reduce carbon")
            .style("font-size", "32px");
                
        arcs.append("text")
            .attr("transform", "rotate(90) scale(-1,1)")
            .attr("text-anchor", "middle")
            .attr("dy", "-0.8em")
            .text("emissions to")
            .style("font-size", "32px");
        
        arcs.append("text")
            .attr("transform", "rotate(90) scale(-1,1)")
            .attr("text-anchor", "middle")
            .attr("dy", "0.4em")
            .attr("fill", "#439E3D")
            .text("50% of")
            .style("font-size", "32px")
            .style("font-weight", "bold");
        
        arcs.append("text")
            .attr("transform", "rotate(90) scale(-1,1)")
            .attr("text-anchor", "middle")
            .attr("dy", "1.6em")
            .attr("fill", "#439E3D")
            .text("2010 level")
            .style("font-size", "32px")
            .style("font-weight", "bold");
        
        arcs.append("text")
            .attr("transform", "rotate(90) scale(-1,1)")
            .attr("text-anchor", "middle")
            .attr("dy", "2.8em")
            .text("by 2030")
            .style("font-size", "32px");
});